import type { SVGProps } from 'react';

const SvgEdit2 = (props: SVGProps<SVGSVGElement>) => (
  <svg width={15} height={15} viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M11.244 0.25C11.0565 0.25 10.8615 0.325 10.719 0.4675L9.34652 1.84L12.159 4.6525L13.5315 3.28C13.824 2.9875 13.824 2.515 13.5315 2.2225L11.7765 0.4675C11.6265 0.3175 11.439 0.25 11.244 0.25ZM8.54402 4.765L9.23402 5.455L2.43902 12.25H1.74902V11.56L8.54402 4.765ZM0.249023 10.9386L8.54402 2.64355L11.3565 5.45605L3.06152 13.7511H0.249023V10.9386Z'
      fill={props.fill ?? '#696F88'}
    />
  </svg>
);

export default SvgEdit2;
